import { useAppSelector } from '@/shared/hooks/store';
import { selectLoginLoading } from '@/store/slices/auth/selectors';
import RegisterFormV2 from '../../components/register-form-v2/form-v2';
import { ICustomersRegisterRequest } from '@/shared/endpoints/customers/models/request';
import { IParams } from '@/shared/types/helpers';
// Components
import './register-v2.css';

import GuardPrimaryIcon from '@/assets/icons/guard-primary.svg';
import RegisterV2Layout from '../../components/register-form-v2/layout';

export const formatPhoneNumberWithDashes = (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
};

interface IProps {
    onSubmit(form: ICustomersRegisterRequest): Promise<void>;
    params: IParams;
}

const RegisterV2 = ({ onSubmit, params }: IProps) => {
    const isLoading = useAppSelector(selectLoginLoading);

    return (
        <div data-testid="register-v2-container" className="flex w-full flex-auto items-start justify-center bg-[#f8f5f0]">
            <RegisterV2Layout icon={GuardPrimaryIcon} subTitle="Your Insurance Looks Good!">
                <RegisterFormV2 params={params} onSubmit={onSubmit} isLoading={isLoading} />
            </RegisterV2Layout>
        </div>
    );
};

export default RegisterV2;
